import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69217b92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ODetalhesEvento__Cabecalho" }
const _hoisted_2 = { class: "ODetalhesEvento__Titulo ajustar-textos-longos" }
const _hoisted_3 = {
  key: 0,
  class: "ODetalhesEvento__Acoes"
}
const _hoisted_4 = { class: "ODetalhesEvento__Conteudo" }
const _hoisted_5 = {
  key: 0,
  class: "OAtividadeNaoPlanejada__Etapas"
}
const _hoisted_6 = {
  key: 1,
  class: "OAtividadeNaoPlanejada__SemAtributos"
}
const _hoisted_7 = { class: "ODetalhesEvento__Profissional" }
const _hoisted_8 = { class: "ODetalhesEvento__NomeEmail" }
const _hoisted_9 = { class: "ODetalhesEvento__Duracao" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "ODetalhesEvento__Icone Icone--info pi pi-clock" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "ODetalhesEvento__Projeto"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "ODetalhesEvento__Icone Icone--info pi pi-map" }, null, -1))
const _hoisted_13 = { class: "ODetalhesEvento__NomeProjeto ajustar-textos-longos" }
const _hoisted_14 = {
  key: 2,
  class: "OAtividadeNaoPlanejada__ComAtributos"
}
const _hoisted_15 = { class: "ODetalhesEvento__Problemas" }
const _hoisted_16 = {
  key: 0,
  class: "ODetalhesEvento__Problema"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-lock Icon--info" }, null, -1))
const _hoisted_18 = { class: "ODetalhesEvento__ProblemaConteudo" }
const _hoisted_19 = { class: "ODetalhesEvento__ProblemaDescricao" }
const _hoisted_20 = {
  class: "ODetalhesEvento__Justificativa",
  "data-testid": "ODetalhesEvento__Justificativa"
}
const _hoisted_21 = {
  key: 0,
  class: "pi pi-exclamation-triangle Icon--info"
}
const _hoisted_22 = {
  key: 1,
  class: "pi pi-flag Icon--info"
}
const _hoisted_23 = { class: "ODetalhesEvento__ProblemaConteudo" }
const _hoisted_24 = { class: "ODetalhesEvento__ProblemaDescricao" }
const _hoisted_25 = {
  key: 0,
  class: "ODetalhesEvento__Justificativa",
  "data-testid": "ODetalhesEvento__Justificativa"
}

import Dialog from "primevue/dialog"
  import Avatar from "primevue/avatar"
  import PButton from "primevue/button"
  import { usarFuncoesStrings } from "@/composable/UsarFuncoesStrings/usarFuncoesStrings"
  import { computed, onUnmounted, ref, watch } from "vue"
  import {
    ModoDeRegistro,
    ProblemaAtividade,
    FasesDaAtividade
  } from "@/repositorios/atividades/atividades.modelos"
  import {
    Anulavel,
    EntidadeGenerica,
  } from "@/types/gerais"
  import { MFormularioAtividadeComAtributos } from "@/components/Atributos"
  import { AEtapas } from "@/components/Gerais"
  import { usarPermissionamento } from "@/composable/UsarPermissionamento/usarPermissionamento"
  import SessaoServico from "@/servicos/sessao.service"
  import { usarProjetosStore } from "@/store/projetos/projetos.store"
  import { storeToRefs } from "pinia"
  import type { OperacaoDePermissionamento } from "@/composable/UsarPermissionamento/modulosDePermissao"
  import { ABotaoDeAcao, MEventoPeriodo } from ".."
  import { useI18n } from "vue-i18n"
  import { CaracteristicaComValor } from "@/components/AtributoComValor"
  import { Etapa } from "@/components/Gerais/AEtapas/AEtapas.modelos"
  import { CaracteristicaStore } from "@/store/atributos/caracteristicas/caracteristicas.store"

  type MapModoDeRegistro = {
    [key in ModoDeRegistro]: string
  }

  interface Props {
    id: string
    idTipoDeAtividade: string
    idUsuarioCriador: string
    idProjeto?: Anulavel<string>
    nomeAtividade: string
    listaDeAtributosCaracteristicaComValor?: CaracteristicaComValor[]
    modoDeRegistroInicio: ModoDeRegistro
    modoDeRegistroFim?: Anulavel<ModoDeRegistro>
    inicio: Date
    fim: Date
    profissional: EntidadeGenerica
    problemas: Anulavel<ProblemaAtividade[]>
    projeto: Anulavel<string>
    visible: boolean
    teleportarPara?: string
    status: string
    faseDaAtividade: FasesDaAtividade
    acaoIniciandoOuFinalizandoAtividade: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ODetalhesEvento',
  props: {
    id: null,
    idTipoDeAtividade: null,
    idUsuarioCriador: null,
    idProjeto: null,
    nomeAtividade: null,
    listaDeAtributosCaracteristicaComValor: null,
    modoDeRegistroInicio: null,
    modoDeRegistroFim: null,
    inicio: null,
    fim: null,
    profissional: null,
    problemas: null,
    projeto: null,
    visible: { type: Boolean },
    teleportarPara: null,
    status: null,
    faseDaAtividade: null,
    acaoIniciandoOuFinalizandoAtividade: { type: Boolean }
  },
  emits: ["update:visible", "onExibirModalDeEditarAtividade", "onExibirModalDeExcluirAtividade", "iniciarAtividade", "finalizarAtividade"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:visible", visible: boolean): void
    (event: "onExibirModalDeEditarAtividade"): void
    (event: "onExibirModalDeExcluirAtividade"): void
    (event: "iniciarAtividade"): void
    (event: "finalizarAtividade"): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    id: string
    idTipoDeAtividade: string
    idUsuarioCriador: string
    idProjeto?: Anulavel<string>
    nomeAtividade: string
    listaDeAtributosCaracteristicaComValor?: CaracteristicaComValor[]
    modoDeRegistroInicio: ModoDeRegistro
    modoDeRegistroFim?: Anulavel<ModoDeRegistro>
    inicio: Date
    fim: Date
    profissional: EntidadeGenerica
    problemas: Anulavel<ProblemaAtividade[]>
    projeto: Anulavel<string>
    visible: boolean
    teleportarPara?: string
    status: string
    faseDaAtividade: FasesDaAtividade
    acaoIniciandoOuFinalizandoAtividade: boolean
  }

  

  const { t } = useI18n()

  const caracteristicasStore = CaracteristicaStore()

  const { id: idUsuarioLogado } =
    SessaoServico.coletarInformacoesDoUsuarioLogado()

  const { id: idProfissionalUsuarioLogado } =
    SessaoServico.coletarInformacoesDeProfissionalDoUsuario()

  const etapas = <Etapa[]>([
    { rotulo: t('etapaAtividade') },
    { rotulo: t('etapaAtributos') }
  ])

  const etapaAtiva = ref<number>(0)

  const aoClicarNaEtapa = (indice: number) => {
    etapaAtiva.value = indice
  }

  const { projetos } = storeToRefs(usarProjetosStore())

  const permissionadorAtividadesRealizadas = usarPermissionamento("AtividadesRealizadas")
  const { pegarIniciais } = usarFuncoesStrings()

  const problemaEhUmAviso = "0001"
  const estaIniciandoOuFinalizandoAtividade = ref(false)

  
  const emitirDisplay = computed({
    get() {
      return props.visible
    },
    set(visible: boolean) {
      emitir("update:visible", visible)
    },
  })

  const mapModoDeRegistro: MapModoDeRegistro = {
    manual: t("correcaoManual"),
    app_aloque: t("peloAppTimesheet"),
    app_gestao: t("peloAppGestao"),
    web: t("peloBrowser"),
    autocompletar: t("autocompletar"),
  }
  const modoRegistroInicio = computed(() => {
    return mapModoDeRegistro[props.modoDeRegistroInicio]
  })
  const modoRegistroFim = computed(() => {
    if (props.modoDeRegistroFim) {
      return mapModoDeRegistro[props.modoDeRegistroFim]
    }

    return null
  })

  const eventoEstaEmAndamento = computed(() => {
    return props.faseDaAtividade === "emAndamento"
  })

  const permissaoParaBotaoDeEditar = computed(() => {
    return possuiPermissaoDeEditar.value && !eventoEstaEmAndamento.value
  })
  const permissaoParaBotaoDeDeletar = computed(() => {
    return possuiPermissaoDeDeletar.value && !eventoEstaEmAndamento.value
  })

  const deveMostrarBotaoDeAtividade = computed(() => {
    const fasesQueNaoDeveMostrar: FasesDaAtividade[] = ["naoPodeIniciar", "finalizada"]

    if (ehEventoTravado.value) {
      return false
    }

    const usuarioTemPermissaoDeVisualizarBotao = props.profissional.id === idProfissionalUsuarioLogado
    const atividadePodeSerIniciada = !fasesQueNaoDeveMostrar.includes(props.faseDaAtividade)

    return atividadePodeSerIniciada && usuarioTemPermissaoDeVisualizarBotao
  })

  const deveExibirEtapas = computed(() => {
    return temAtributos.value
  })

  const temAtributos = computed(() => {
    return props.listaDeAtributosCaracteristicaComValor && props.listaDeAtributosCaracteristicaComValor.length > 0
  })

  const problemasComTextosTratados = (
    problemasComTextosDoBackend: Anulavel<ProblemaAtividade[]>
  ): Anulavel<ProblemaAtividade[]> => {
    if (problemasComTextosDoBackend) {
      const problemasComTextosTratados = problemasComTextosDoBackend.map((problema) => {
        return {
          ...problema,
          problema: t(`problemas[${problema.codigo}].problema`)
        }
      })

      return problemasComTextosTratados
    }
  }

  const verificarSeSupervisorEhResponsavelDoProjeto = (
    permissao: OperacaoDePermissionamento
  ): boolean => {
    const projetoSelecionado = projetos.value.find(
      (projeto) => projeto.id === props.idProjeto
    )

    if (!projetoSelecionado) {
      return verificarSePerfilPessoalPodeAlterar(permissao)
    }

    const { usuariosResponsaveis } = projetoSelecionado

    return usuariosResponsaveis.some(
      (idResponsaveis) => idResponsaveis === idUsuarioLogado
    )
  }

  const verificarSePerfilPessoalPodeAlterar = (
    permissao: OperacaoDePermissionamento
  ): boolean => {
    const idUsuarioCriador = props.idUsuarioCriador
    const possuiPermissao =
      permissionadorAtividadesRealizadas.verificarPermissao(permissao)
    const foiQuemCriou =
      permissionadorAtividadesRealizadas.verificarPermissaoIntrinseca(
        permissao,
        { id: idUsuarioCriador }
      )
    return possuiPermissao && foiQuemCriou
  }

  const verificarPermissaoDeAcordoComPerfil = (
    permissao: OperacaoDePermissionamento
  ) => {
    return (
      permissionadorAtividadesRealizadas.verificarPermissaoPorGrupo(
        permissao,
        "outros"
      ) ||
      verificarSeSupervisorEhResponsavelDoProjeto(permissao) ||
      verificarSePerfilPessoalPodeAlterar(permissao)
    )
  }

  const possuiPermissaoDeEditar = computed(() => {
    return verificarPermissaoDeAcordoComPerfil("editar")
  })

  const possuiPermissaoDeDeletar = computed(() => {
    return verificarPermissaoDeAcordoComPerfil("deletar")
  })

  const ehEventoTravado = computed(() => {
    return props.status === "travado"
  })

  const ativarModalExcluirAtividade = () => {
    emitir("onExibirModalDeExcluirAtividade")
  }

  const abrirModalDeEditarAtividade = () => {
    emitir("onExibirModalDeEditarAtividade")
  }

  const finalizarAtividadePlanejada = (): void => {
    estaIniciandoOuFinalizandoAtividade.value = true
    emitir("finalizarAtividade")
  }

  const iniciarAtividadePlanejada = (): void => {
    estaIniciandoOuFinalizandoAtividade.value = true
    emitir("iniciarAtividade")
  }

  watch(
    () => props.acaoIniciandoOuFinalizandoAtividade,
    (estadoDeCarregamento: boolean) =>
      (estaIniciandoOuFinalizandoAtividade.value = estadoDeCarregamento)
  )

  onUnmounted(() => {
    caracteristicasStore.resetarCaracteristicas()
  })

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: _unref(emitirDisplay),
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirDisplay) ? (emitirDisplay).value = $event : null)),
    "append-to": __props.teleportarPara,
    class: _normalizeClass(["ODetalhesEvento", _unref(deveMostrarBotaoDeAtividade) && 'ODetalhesEvento--ComBotaoDeAcao']),
    "data-testid": "ODetalhesEvento",
    "dismissable-mask": "",
    draggable: false,
    header: "Header",
    modal: true,
    style: { 'min-width': '630px' }
  }, _createSlots({
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.nomeAtividade), 1),
        (!_unref(ehEventoTravado))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_unref(permissaoParaBotaoDeEditar))
                ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                    key: 0,
                    onClick: abrirModalDeEditarAtividade,
                    class: "ODetalhesEvento__IButton p-button-rounded p-button-sm",
                    "data-testid": "ODetalhesEvento__Editar",
                    icon: "pi pi-pencil"
                  }, null, 512)), [
                    [
                      _directive_tooltip,
                      _unref(t)('editar'),
                      void 0,
                      { top: true }
                    ]
                  ])
                : _createCommentVNode("", true),
              (_unref(permissaoParaBotaoDeDeletar))
                ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                    key: 1,
                    onClick: ativarModalExcluirAtividade,
                    class: "ODetalhesEvento__IButton p-button-rounded p-button-sm",
                    "data-testid": "ODetalherEvento__Excluir",
                    icon: "pi pi-trash"
                  }, null, 512)), [
                    [
                      _directive_tooltip,
                      _unref(t)('excluir'),
                      void 0,
                      { top: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (_unref(deveExibirEtapas))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_unref(AEtapas), {
                clicavel: "",
                largura: "50%",
                etapas: _unref(etapas),
                "indice-ativo": etapaAtiva.value,
                onEtapaClicada: aoClicarNaEtapa
              }, null, 8, ["etapas", "indice-ativo"])
            ]))
          : _createCommentVNode("", true),
        (etapaAtiva.value === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(Avatar), {
                  class: "ODetalhesEvento__ProfissionalFoto",
                  label: _unref(pegarIniciais)(__props.profissional.nome),
                  shape: "circle",
                  size: "large",
                  style: { 'background-color': '#00707d', color: 'white' }
                }, null, 8, ["label"]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(__props.profissional.nome), 1),
                  _createElementVNode("small", null, _toDisplayString(__props.profissional?.email), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_unref(MEventoPeriodo), {
                  "evento-esta-em-andamento": _unref(eventoEstaEmAndamento),
                  fim: __props.fim,
                  inicio: __props.inicio,
                  "modo-registro-fim": _unref(modoRegistroFim),
                  "modo-registro-inicio": _unref(modoRegistroInicio),
                  "rotulo-fim": _unref(t)('fim'),
                  "rotulo-inicio": _unref(t)('inicio')
                }, null, 8, ["evento-esta-em-andamento", "fim", "inicio", "modo-registro-fim", "modo-registro-inicio", "rotulo-fim", "rotulo-inicio"])
              ]),
              (__props.projeto)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("span", _hoisted_13, _toDisplayString(__props.projeto), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (etapaAtiva.value === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_unref(MFormularioAtividadeComAtributos), { "lista-de-atributos-caracteristica-com-valor": __props.listaDeAtributosCaracteristicaComValor }, null, 8, ["lista-de-atributos-caracteristica-com-valor"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 2
  }, [
    (__props.problemas || _unref(ehEventoTravado) || _unref(deveMostrarBotaoDeAtividade))
      ? {
          name: "footer",
          fn: _withCtx(() => [
            (_unref(deveMostrarBotaoDeAtividade))
              ? (_openBlock(), _createBlock(_unref(ABotaoDeAcao), {
                  key: 0,
                  onFinalizarAtividade: finalizarAtividadePlanejada,
                  onIniciarAtividade: iniciarAtividadePlanejada,
                  "esta-carregando": estaIniciandoOuFinalizandoAtividade.value,
                  "fase-da-atividade": __props.faseDaAtividade
                }, null, 8, ["esta-carregando", "fase-da-atividade"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              (_unref(ehEventoTravado))
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('atividadeTravada')), 1),
                      _createElementVNode("small", _hoisted_20, _toDisplayString(_unref(t)('naoPossivelFazerAlteracoesNestaAtividade')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(problemasComTextosTratados(__props.problemas), (problema) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: problema.codigo,
                  class: "ODetalhesEvento__Problema"
                }, [
                  (problema.codigo === problemaEhUmAviso)
                    ? (_openBlock(), _createElementBlock("em", _hoisted_21))
                    : (_openBlock(), _createElementBlock("em", _hoisted_22)),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, _toDisplayString(problema.problema), 1),
                    (problema.justificativa)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_25, _toDisplayString(problema.justificativa), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["visible", "append-to", "class"]))
}
}

})